import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

const LINKS = [
  { label: "Manifesto", href: "#manifesto", testid: "nav-link-manifesto" },
  { label: "Plans", href: "#plans", testid: "nav-link-plans" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-xl bg-paper/85 border-b border-ink/10"
      data-testid="main-nav"
    >
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2.5" data-testid="nav-brand">
          <span className="relative flex h-3 w-3">
            <span className="absolute inline-flex h-full w-full rounded-full bg-gold/50 blur-[6px]" />
            <span className="relative inline-flex h-3 w-3 rounded-full bg-gold" />
          </span>
          <span className="font-serif text-xl font-semibold tracking-tight">Dual Care</span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm font-medium text-ink-muted hover:text-ink transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <a
            href="https://dualcare4u.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-app-link"
            className="text-sm font-medium text-clay hover:text-clay-dark transition-colors duration-300"
          >
            Open App
          </a>
        </nav>
        <motion.a
          href="#contact"
          data-testid="nav-contact-cta"
          whileHover={{ scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          className="inline-flex items-center gap-2 rounded-full bg-ink text-paper text-sm font-medium px-5 py-2.5 hover:bg-clay transition-colors duration-300"
        >
          Contact Us <ArrowRight className="h-4 w-4" />
        </motion.a>
      </div>
    </motion.header>
  );
}
